import { useState } from "react";
import { useNavigate } from "react-router-dom";

export const useTicketsTableActions = (ticketApis, onRefresh, onEdit) => {
  const [dropdownIndex, setDropdownIndex] = useState(null);
  const [showEdit, setShowEdit] = useState(false);
  const [editData, setEditData] = useState(null);
  const [showViewMore, setShowViewMore] = useState(false);
  const [viewData, setViewData] = useState(null);
  const [showDeleteDialog, setShowDeleteDialog] = useState(false);
  const [deleteData, setDeleteData] = useState(null);
  const navigate = useNavigate();

  const toggleDropdown = (index) => {
    setDropdownIndex(dropdownIndex === index ? null : index);
  };

  const handleActionClick = async (action, rowData) => {
    setDropdownIndex(null); // Close dropdown

    switch (action) {
      case "view":
        navigate(`/tickets/${rowData.id}`, { state: rowData });
        break;
      case "edit":
        // Call the onEdit callback if provided
        if (onEdit) {
          onEdit(rowData);
        } else {
          // Fallback to old behavior if no callback provided
          setEditData(rowData);
          setShowEdit(true);
        }
        break;
      case "delete":
        // Show custom delete dialog
        setDeleteData(rowData);
        setShowDeleteDialog(true);
        break;
      default:
        console.log(`Unknown action: ${action}`);
    }
  };

  const handleDeleteConfirm = async () => {
    if (deleteData) {
      try {
        await ticketApis.deleteTicketById(deleteData.id);
        if (onRefresh) onRefresh();
        setShowDeleteDialog(false);
        setDeleteData(null);
      } catch (error) {
        console.error("Error deleting ticket:", error);
        alert("Failed to delete ticket. Please try again.");
      }
    }
  };

  const handleDeleteCancel = () => {
    setShowDeleteDialog(false);
    setDeleteData(null);
  };

  return {
    dropdownIndex,
    toggleDropdown,
    handleActionClick,
    showEdit,
    setShowEdit,
    editData,
    setEditData,
    showViewMore,
    setShowViewMore,
    viewData,
    setViewData,
    showDeleteDialog,
    setShowDeleteDialog,
    deleteData,
    handleDeleteConfirm,
    handleDeleteCancel,
  };
};
